export default {"src":"/_next/static/media/notify-img.4e30308a.svg","height":118,"width":182};